export const C = {
  primary:  '#2d7a2d',
  light:    '#f1f8f1',
  border:   '#c8dfc8',
  green:    '#1b5e20',
  greenBg:  '#e8f5e9',
  blue:     '#1565c0',
  blueBg:   '#e3f2fd',
  amber:    '#e65100',
  amberBg:  '#fff3e0',
  purple:   '#1b5e20',
  purpleBg: '#e8f5e9',
  bar1:     '#2d7a2d',
  bar2:     '#7ab87a',
};

export const STATUT_NOTAIRE_OPTIONS = [
  { value: 'NOT_YET',  label: 'Pas encore signé' },
  { value: 'CHEZ',     label: 'Signé client' },
  { value: 'EN_COURS', label: 'Signature en cours' },
  { value: 'SIGNE',    label: 'Signé notaire' },
];

export const STATUTS_ENCAISSE = ['ENCAISSE','NOTAIRE','REPRESENTE','A_NE_PAS_VERSER_R','EI','VERSEMENT'];

export const MOIS_COURTS = ['JAN','FÉV','MARS','AVR','MAI','JUIN','JUIL','AOÛT','SEPT','OCT','NOV','DÉC'];

export const REC_STATUTS = [
  { key: 'ptf',     label: 'PTF',      info: 'Chèques postdatés (PTF), réceptionnés (RECEPTION) et à ne pas verser (A_NE_PAS_VERSER_R, A_NE_PAS_VERSER_NR) — en attente de présentation ou de régularisation.', values: ['RECEPTION','PTF','A_NE_PAS_VERSER_R','A_NE_PAS_VERSER_NR'], color: '#1565c0', bg: '#e3f2fd' },
  { key: 'verse',   label: 'Versé',    info: 'Montants versés à la banque via EI, représentés ou en cours de versement — statuts EI, REPRESENTE, VERSEMENT.',                                                       values: ['EI','REPRESENTE','VERSEMENT'],                               color: '#6a1b9a', bg: '#f3e5f5' },
  { key: 'encaise', label: 'Encaissé', info: 'Montants effectivement encaissés et confirmés par la banque — statuts NOTAIRE, ENCAISSE.',                                                                             values: ['NOTAIRE','ENCAISSE'],                                        color: '#2e7d32', bg: '#c8e6c9' },
  { key: 'impaye',  label: 'Impayé',   info: 'Paiements revenus impayés de la banque (statut = IMPAYE). À relancer ou remplacer.',                                                                                  values: ['IMPAYE'],                                                   color: '#c62828', bg: '#ffebee' },
];

export const DUREE_BANDS = [
  { key: 'nb30j',    label: '≤ 30 j',    info: 'Dossiers dont la durée de traitement (réservation → PN ou clôture) est de 30 jours ou moins.',   color: '#2e7d32', bg: '#e8f5e9' },
  { key: 'nb60j',    label: '31 – 60 j', info: 'Dossiers traités entre 31 et 60 jours.',                                                          color: '#1565c0', bg: '#e3f2fd' },
  { key: 'nb90j',    label: '61 – 90 j', info: 'Dossiers traités entre 61 et 90 jours — délai à surveiller.',                                     color: '#e65100', bg: '#fff3e0' },
  { key: 'nbSup90j', label: '> 90 j',    info: 'Dossiers traités en plus de 90 jours — nécessitent une attention particulière.',                   color: '#c62828', bg: '#ffebee' },
];

export const COM_COLORS    = ['#1565c0', '#2e7d32', '#6a1b9a', '#e65100', '#6d4e36', '#c62828'];
export const BORDER_COLORS = ['#8b5e3c', '#6d4e36', '#e6b87b'];

// Couleur logique par type de bien (bien.TYPE) : par famille (résidentiel, R+N, Com, Hab, Eco, FB, industriel...)
const RPLUS_BLUES = ['#90caf9', '#64b5f6', '#42a5f5', '#1e88e5', '#1565c0', '#0d47a1'];
export const getBienTypeColor = (type) => {
  const t = (type || '').toLowerCase().trim();
  if (/villa/.test(t))       return '#1b5e20';
  if (/appartement/.test(t)) return '#2e7d32';
  if (/eco/.test(t))         return '#e65100';
  if (/com\s*g/.test(t))     return '#4a148c';
  if (/\bcom\b/.test(t))     return '#6a1b9a';
  if (/hab/.test(t))         return '#00897b';
  if (/^fb\b/.test(t))       return '#3949ab';
  if (/industriel/.test(t))  return '#5d4037';
  if (/logistique/.test(t))  return '#795548';
  if (/equipement/.test(t))  return '#8d6e63';
  if (/magasin/.test(t))     return '#ad1457';
  const m = t.match(/^r\+(\d+)$/);
  if (m) return RPLUS_BLUES[Math.min(parseInt(m[1], 10) - 1, RPLUS_BLUES.length - 1)];
  return '#888';
};

export const SEC_DEFAULT = ['kpi','notaire-soon','statut-lots','situation-encours','commissions','projets','commerciaux','ca-projet','graphiques','analyse-rec','synthese','stock','tableau','detail-ventes','detail-rec','detail-pn','duree-traitement','situation-commerciale'];
export const SEC_LABELS  = {
  'kpi':               'KPI Globaux',
  'notaire-soon':      'Prochainement au Notaire',
  'statut-lots':       'Statut Lots Vendus',
  'situation-encours': 'Situation Encours',
  'commissions':       'Commissions',
  'projets':           'Performance par Projet',
  'commerciaux':       'Performance par Commercial',
  'ca-projet':         'CA par Projet',
  'graphiques':        'Graphiques Mensuels',
  'analyse-rec':       'Analyse Recouvrement',
  'synthese':          'Synthèse par Type',
  'stock':             'Stock / Déstockage',
  'tableau':           'Détail par Projet / Type',
  'detail-ventes':     'Détail Ventes',
  'detail-rec':        'Détail Recouvrement',
  'detail-pn':         'Détail Passages Notaire',
  'duree-traitement':       'Durée de Traitement Notaire',
  'situation-commerciale':  'Situation Commerciale',
};

export const selectStyles = {
  control: (b, s) => ({
    ...b,
    minHeight: 34, borderColor: s.isFocused ? C.primary : C.border,
    boxShadow: s.isFocused ? `0 0 0 1px ${C.primary}` : 'none',
    borderRadius: 7, fontSize: '0.8rem'
  }),
  option: (b, s) => ({
    ...b,
    fontSize: '0.8rem',
    background: s.isSelected ? C.primary : s.isFocused ? C.light : '#fff',
    color: s.isSelected ? '#fff' : '#333'
  }),
  menu: (b) => ({ ...b, zIndex: 9999 }),
};

export const inputStyle = {
  height: 34, borderRadius: 7, border: `1px solid ${C.border}`,
  padding: '0 10px', fontSize: '0.8rem', color: '#333', background: '#fff',
  outline: 'none', width: '100%', boxSizing: 'border-box',
};

export const detailSectionCard = {
  borderRadius: 8, border: '2px solid #d4c8bc',
  boxShadow: '0 1px 4px rgba(109,78,54,0.08)',
  background: '#fff', overflow: 'hidden', marginTop: 16,
};
